import { deleteUser, getUser } from "@api/user";
import useAuth from "@hooks/Auth/useAuth";
import useModalActions from "@hooks/common/useModalAction";
import { usePermissionMutation } from "@hooks/Permission/usePermissionMutation";
import { usePermissionQuery } from "@hooks/Permission/usePermissionQuery";
import { APIError } from "@models/index";
import { UserSchema } from "@models/User";
import { useQueryClient } from '@tanstack/react-query';

export default function useGetUser(){
  const { accessToken } = useAuth();

  const query = usePermissionQuery<UserSchema[]>({
    queryKey: ['User'],
    queryFn: async () => {
      const res = await getUser({ accessToken });
      if (res.status === 200 || res.status === 201) {
        return res.data.data;
      } else {
        return [];
      }
    },
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  return query;
}

export function useDeleteUser(){
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();
  const { selectAction, errorAction } = useModalActions();

  return usePermissionMutation<void, string>({
    mutationFn: async (id: string) => {
      await new Promise<void>((resolve, reject) => {
        selectAction("Are you sure you want to delete this user?", async () => {
          try {
            await deleteUser({ accessToken, id });
            resolve();
          } catch (err) {
            reject(err);
          }
        });
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["User"] });
    },
    onError: (error) => {
      errorAction(error as APIError, "Failed. Please contact the administrator.");
    },
  });
}
